import * as React from 'react';
import {
  Logging,
  API,
  ResponseError,
  NotificationData,
  Seller,
  SellerCollection,
} from '@vcd-ecm-ui/Common';
import { useDispatch } from 'react-redux';

const useSellers = (
  gatewayEndPoint: string,
  sellerSearchText: string,
): [Seller[], boolean, NotificationData] => {
  const [sellers, setSellers] = React.useState(null);
  const [searching, setSearching] = React.useState(false);
  const [sellerNotification, setSellerNotification] = React.useState(null);
  const dispatch = useDispatch();

  const getSellers = () => async (): Promise<void> => {
    try {
      const api = new API(gatewayEndPoint);

      let startRow = 0;
      const pageSize = 1000;
      let sellersArray: Seller[] = [];
      let totalSellers = 0;
      let customFilter: string = null;
      const sortModel: string[] = null; // ['name, asc']; // FIX ME Sorting on Sellers is Broken

      if (sellerSearchText) {
        const filterValue = `(code ct '${sellerSearchText}' or name ct '${sellerSearchText}')`;
        customFilter = `$filter=${encodeURIComponent(filterValue)}`;
        customFilter = null; // FIX ME Filtering on Sellers is Broken
      }
      // Read all the Sellers
      do {
        const endRow = startRow + pageSize;
        // eslint-disable-next-line no-await-in-loop
        const sellerCollection: SellerCollection = await api.ecwizard.getSellersV41(startRow, endRow, null, sortModel, customFilter);

        // Get the Total Number of Sellers
        totalSellers = sellerCollection['@odata.count'];

        Logging.Debug('Load Sellers Page:', startRow, endRow, totalSellers, sellerCollection.value.length);

        // Adjust the Start Row
        startRow = endRow;

        // Append the Sellers
        sellersArray = sellersArray.concat(sellerCollection.value);
      } while (sellersArray.length < totalSellers);

      Logging.Info('Get Sellers:', sellersArray.length);

      setSellers(sellersArray);

      setSearching(false);
    } catch (error) {
      const notification: NotificationData = {
        type: 'Error',
        title: 'Sellers Read Error',
        description: 'Unable to read Sellers',
        error: error as ResponseError,
      };
      setSellerNotification(notification);
      setSearching(false);
    }
  };

  React.useEffect(() => {
    Logging.Debug('Searching Sellers', sellerSearchText);

    if (sellerSearchText) {
      setSearching(true);
      dispatch(getSellers());
    } else {
      setSearching(false);
      setSellers(null);
    }

    return (): void => {
      setSellerNotification(null);
    };
  }, [sellerSearchText]);

  return [sellers, searching, sellerNotification];
};

export default useSellers;
